import { shouldInsertIndicator } from './chatIndicatorHelpers';

export function shouldInsertScopeChange(messages, newLabel) {
  return shouldInsertIndicator(messages, 'scope_change', 'scope', newLabel);
}

export function deriveScopeKindFromScope(scope) {
  if (!scope || typeof scope !== 'object') return 'org';
  if (scope.repositoryId) return 'repository';
  if (scope.projectId) return 'project';
  if (scope.streamId) return 'stream';
  if (scope.memberUserId) return 'member';
  return 'org';
}

export function createScopeChangeMessage({ kind, label }: any) {
  return {
    id: `scope-${Date.now()}`,
    type: 'scope_change',
    scope: { kind, label },
  };
}

export function insertScopeChangeBeforeMessage(messages, scopeChangeMsg, messageId) {
  if (!scopeChangeMsg) return messages;
  const idx = messages.findIndex((m) => m.id === messageId);
  if (idx < 0) return [...messages, scopeChangeMsg];
  return [...messages.slice(0, idx), scopeChangeMsg, ...messages.slice(idx)];
}
